import { gql } from "@apollo/client";

export const CAR_QUICK_ADD_SEARCH_QUERY = gql`
  query CarQuickAddSearch($search: String!) {
    cars(
      where: {
        anyOf: [
          { field: { licence: { like: $search } } }
          { field: { additional_info: { like: $search } } }
        ]
      }
      first: 100
    ) {
      data {
        id
        licence
        additional_info
        freestock_tire
      }
    }
  }
`;
